import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { UserSectionStats } from './user-section.model';

export class UserSectionStateModel extends EntityStateModel<UserSectionStats> {
    constructor() {
        super();
    }
}
